const state = {
  isSidebarActive: true,
  breakpoint:      null,
  sidebarWidth:    "default",
  reduceButton:    false,
  sidebarItemsMin: false,
  bodyOverlay:     false,
  windowWidth:     null,

  sidebarMin:    null,
  sidebarActive: false,
  sidebarMobile: null,
  highContrast:  false,
  fontLarger:    false,

  maintenance: false,
  error404:    false,
  forbidden:   false,
};

export default state;
